let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6rF46")).then(() => parcelRequire('7PW51'));